import { Box, Button } from '@mui/material'
import ImageBanner from 'components/image-banner'
import InviteSVG from 'components/svg/invite'

import LogoTheme from 'components/logo-theme'
import WrapperPermission from 'components/wrapper-permission'
import { useStyles } from './styles'
import useComponent from './use-component'

const InviteResponsibleSuccess = () => {
  const { theme, handleEnter, handleBack } = useComponent()

  const classes = useStyles()

  return (
    <Box className={classes.container}>
      <Box className={classes.mainWrapper}>
        <WrapperPermission>
          <Box className={classes.connectBox}>
            <LogoTheme />

            <p className={classes.formTitle}>Convite enviado com sucesso!</p>
            <p className={classes.formSubTitle}>
              O convite foi enviado ao responsável para realizar a conexão com o eSocial. Agora é só aguardar a conexão
              para simplificar a compra e gestão de benefícios. Enquanto você aguarda, acesse a plataforma para conhecer
              mais.
            </p>

            <Button
              fullWidth
              size='large'
              type='button'
              onClick={handleEnter}
              variant='contained'
              sx={{
                mt: 2,
                mb: 0,
                '&.Mui-disabled': {
                  backgroundColor: '#8C9097 !important',
                  color: '#FFF !important',
                },
              }}
            >
              ACESSAR A PLATAFORMA
            </Button>

            {/* <span
              onClick={handleBack}
              color='inherit'
              className={classes.buttons}
            >
              Voltar
            </span> */}
          </Box>
        </WrapperPermission>

        <ImageBanner
          title='O responsável receberá um email e poderá realizar a conexão segura com o eSocial. Agora, conheça a plataforma!'
          banner={<InviteSVG />}
        />
      </Box>
    </Box>
  )
}

export default InviteResponsibleSuccess
